import style from "./insights-summary.module.css";

interface InsightsSummaryCardProps {
  title: string;
  value: string | number;
}

export function InsightsSummaryCard({ title, value }: InsightsSummaryCardProps) {
  return (
    <div className={style.card}>
      <span className={style.cardValue}>{value}</span>
      <span className={style.cardTitle}>{title}</span>
    </div>
  );
}
